// Modules
import { createSelector } from 'reselect';

// Types
import { Store } from '../types/store';
import { CommonState } from '../types/common';

export const common = (state: Store): CommonState => state.common;

// Selector to Capitalize Language
export const capitalizedLang = () =>
	createSelector(common, ({ lang }) => lang.toUpperCase());
